import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { SORTED_QUESTION } from './constants';
import {
  SortedQuestionDataActionTypes,
  SortedQuestionError,
  SortedQuestionState,
  SortedQuestionSuccess,
} from './types';

const initialState: SortedQuestionState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: SortedQuestionDataActionTypes,
  ): SortedQuestionState => {
    switch (action.type) {
      case SORTED_QUESTION + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case SORTED_QUESTION + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as SortedQuestionSuccess).payload;
        break;
      }
      case SORTED_QUESTION + FAILURE: {
        draft.status = rejected;
        draft.error = (action as SortedQuestionError).error;
        break;
      }
      case SORTED_QUESTION + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
